// ⚠️ FILE SINH TỰ ĐỘNG bởi scripts/gen-i18n-shims.mjs — đừng sửa tay.
// Cụm: pages-auth
import { messages } from '../../../locales/vi/pages-auth.mjs';
import { registerCluster } from '../runtime.js';

const loaders = {
  en: () => import('../../../locales/en/pages-auth.mjs'),
  fr: () => import('../../../locales/fr/pages-auth.mjs'),
  es: () => import('../../../locales/es/pages-auth.mjs'),
};

registerCluster('pages-auth', messages, (locale) => loaders[locale]());
